// extracted by mini-css-extract-plugin
module.exports = {"button":"button-g4HTb","close":"close-1vwu_"};